import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import type { PhosphorIconName } from 'phosphor-icons'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface SideNavIconSignature {
  Element: HTMLSpanElement
  Args: {
    url?: string
    alt?: string
    phosphorIcon?: PhosphorIconName
  }
}

export class SideNavIconComponent extends Component<SideNavIconSignature> {
  @service subscriptionType!: SubscriptionTypeService

  get iconBackgroundClassNames() {
    switch (this.subscriptionType.current) {
      case SubscriptionType.Reading:
        return 'bg-oceany-blue-325'
      case SubscriptionType.Maths:
        return 'bg-ms-green-300'
      case SubscriptionType.Writing:
        return 'bg-wl-blue-300'
      default:
        return ''
    }
  }

  <template>
    {{#if @url}}
      {{! When the rounding is directly applied to the img el, there is very subtle clipping for some icons }}
      <span class="rounded-full {{this.iconBackgroundClassNames}}" ...attributes>
        <img data-test-sidenav-accordion-label-icon alt={{@alt}} class="h-[25px] w-[25px]" src={{@url}} />
      </span>
    {{else if @phosphorIcon}}
      <span
        class="flex h-[25px] w-[25px] items-center justify-center rounded-full {{this.iconBackgroundClassNames}}"
        ...attributes
      >
        <PhosphorIcon @icon={{@phosphorIcon}} class="h-4 w-4 text-white" />
      </span>

    {{/if}}
  </template>
}

export default SideNavIconComponent
